import React from 'react';
import { useTranslation } from 'react-i18next';

const SANS = { fontFamily: "'Plus Jakarta Sans', sans-serif" };

const PractitionerBadge = () => {
  const { t } = useTranslation();
  return (
    <div style={{
      border: '1px solid rgba(16,54,66,0.15)', borderRadius: 10,
      padding: '7px 12px', display: 'flex', alignItems: 'center', gap: 10,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5, flexShrink: 0 }}>
        <svg width="11" height="24" viewBox="0 0 16 34" fill="none" aria-hidden="true">
          <path d="M9 33 C8.5 26 8 18 9 3" stroke="#103642" strokeWidth="1" strokeLinecap="round" strokeOpacity="0.35"/>
          <path d="M9 29 C5 27 1 22 3 17 C6 19 9 24 9 29Z" fill="#103642" fillOpacity="0.6"/>
          <path d="M9 22 C5 20 1 15 3 10 C6 12 9 17 9 22Z" fill="#103642" fillOpacity="0.6"/>
          <path d="M9 15 C5 13 2 8 4 4 C7 6 9 11 9 15Z" fill="#103642" fillOpacity="0.55"/>
          <path d="M9 8 C7 7 5 4 7 2 C8 4 9 6 9 8Z" fill="#103642" fillOpacity="0.5"/>
        </svg>
        <div style={{ textAlign: 'center' }}>
          <p style={{ ...SANS, fontSize: 8, fontWeight: 800, letterSpacing: '0.1em',
            textTransform: 'uppercase', color: '#103642', margin: 0, lineHeight: 1.3 }}>
            {t('LP_BadgeLabelLine1')}
          </p>
          <p style={{ ...SANS, fontSize: 8, fontWeight: 800, letterSpacing: '0.1em',
            textTransform: 'uppercase', color: '#103642', margin: 0, lineHeight: 1.3 }}>
            {t('LP_BadgeLabelLine2')}
          </p>
        </div>
        <svg width="11" height="24" viewBox="0 0 16 34" fill="none" aria-hidden="true" style={{ transform: 'scaleX(-1)' }}>
          <path d="M9 33 C8.5 26 8 18 9 3" stroke="#103642" strokeWidth="1" strokeLinecap="round" strokeOpacity="0.35"/>
          <path d="M9 29 C5 27 1 22 3 17 C6 19 9 24 9 29Z" fill="#103642" fillOpacity="0.6"/>
          <path d="M9 22 C5 20 1 15 3 10 C6 12 9 17 9 22Z" fill="#103642" fillOpacity="0.6"/>
          <path d="M9 15 C5 13 2 8 4 4 C7 6 9 11 9 15Z" fill="#103642" fillOpacity="0.55"/>
          <path d="M9 8 C7 7 5 4 7 2 C8 4 9 6 9 8Z" fill="#103642" fillOpacity="0.5"/>
        </svg>
      </div>
      <div style={{ width: '1px', height: 26, background: 'rgba(16,54,66,0.15)', flexShrink: 0 }} />
      <p style={{ ...SANS, fontSize: 11, fontWeight: 600, color: '#103642',
        margin: 0, lineHeight: 1.4 }}>
        {t('LP_BadgeText')}
      </p>
    </div>
  );
};

export default PractitionerBadge;
